import * as React from "react";
import * as ReactRedux from "react-redux";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ACTIONS } from "./../../controllers/App/actions";
import { iNavData } from "../../models/models";
import { IStoreState } from "../../_reducers";
import { iActionType, Translation } from "../../models/models";
import { SCREEN_WIDTH } from "../../constants";
import { Footer } from "../../components/ui/Footer/Footer";
import { LinkButton } from "../../components/ui/Button/Button";
import { PortraitView } from "../../components/ui/PortraitView/PortraitView";
import { IS_MOBILE } from "../../config";

export interface SelectionPageProps extends ReactRedux.DispatchProp<any> {
  className?: string;
  locale: Translation;
  data?: any;
  navData?: iNavData[];
  onSetGraph?: any;
}

const INIT_STATE: SelectionPageState = {};

export interface SelectionPageState {}

export class SelectionPage extends React.Component<
  SelectionPageProps,
  SelectionPageState
> {
  constructor(props: SelectionPageProps) {
    super(props);
    this.state = INIT_STATE;
  }

  render() {
    let { props, state } = this;
    let cls = this.props.className || "";

    return (
      <div className={"selection-page " + cls}>
        <div className="row">
          <div className="col s12 m12 l12">
            <div className="selection-page__client-logo">
              <a href={this.props.locale.clientUrl} target="_blank">
                <img
                  alt="The UK Domain - Helping businesses achieve more online"
                  src="img/client-logo.png"
                />
              </a>
            </div>

            {SCREEN_WIDTH.IS_SMALL() && IS_MOBILE ? (
              <PortraitView locale={this.props.locale} />
            ) : (
              <div className="selection-page__splash-info">
                <a href="/#">
                  <img
                    alt="The UK Domain - Helping businesses achieve more online"
                    src="img/campaign-logo.png"
                  />
                </a>
                <p>{this.props.locale.selectionInfo}</p>

                <div className="selection-page__buttons">
                  <LinkButton
                    className="selection-page__buttons--giants"
                    href="#/tech-giants/overall"
                  >
                    {this.props.locale.buttonTech}
                  </LinkButton>
                  <LinkButton
                    className="selection-page__buttons--unicorns"
                    href="#/unicorns/overall"
                  >
                    {this.props.locale.buttonUni}
                  </LinkButton>
                </div>
              </div>
            )}
          </div>
        </div>

        <Footer locale={this.props.locale} />
      </div>
    );
  }
}

const mapStateToProps = (
  state: IStoreState,
  ownProps
): Partial<SelectionPageProps> => {
  return {
    locale: state.app.locale,
    data: state.app.data,
    navData: state.app.navData
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectionPage);
